export default __webpack_public_path__ + "static/media/family.f8db5985.png";